<template>
<svg viewBox="0 0 20 20" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-fill-file`]" width="1em" height="1em" v-bind="$attrs"><path d="M6.42596 2.02197C6.89264 2.02197 7.12613 2.02194 7.35077 2.05615C7.74051 2.11556 8.11505 2.25144 8.45233 2.45557C8.64682 2.57328 8.8263 2.72277 9.18475 3.02197C9.54288 3.3209 9.72191 3.47071 9.9162 3.58838C10.2534 3.79249 10.6281 3.92836 11.0178 3.98779C11.2425 4.02205 11.4766 4.02197 11.9435 4.02197H15.592C16.7121 4.02197 17.2726 4.02176 17.7004 4.23975C18.0766 4.43147 18.3827 4.73759 18.5744 5.11377C18.7924 5.54159 18.7922 6.1021 18.7922 7.22217V13.1772C18.7922 14.8573 18.7919 15.6976 18.465 16.3394C18.1774 16.9038 17.718 17.3633 17.1535 17.6509C16.5119 17.9776 15.6718 17.978 13.9924 17.978H6.008C4.32814 17.978 3.48758 17.9777 2.84589 17.6509C2.2814 17.3633 1.82198 16.9038 1.53436 16.3394C1.20749 15.6976 1.20721 14.8572 1.20721 13.1772V5.22217C1.20721 4.1021 1.20798 3.54159 1.42596 3.11377C1.61773 2.73769 1.92384 2.4314 2.29999 2.23975C2.72773 2.02202 3.28785 2.02197 4.40741 2.02197H6.42596ZM5.15839 6.35791C4.6061 6.35791 4.15839 6.80563 4.15839 7.35791V8.35791H15.841V7.35791C15.841 6.80563 15.3933 6.35791 14.841 6.35791H5.15839Z"/></svg>
</template>
<script>

export default {
  name: 'IconFillFile',
  props: {
    prefix: {
        type: String,
        default: 'sc',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
